export const LESSON_SET_INFO = 'LESSON_SET_INFO';



// WEBPACK FOOTER //
// ./src/modules/lessons/cards/LessonCard/action_types.js